// client/src/components/AffiliatesNavbar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUser, FaReceipt, FaFileInvoiceDollar } from 'react-icons/fa';
import { SidebarBrand } from '../shared/BrandLogo';
import '../CSS/Navbar.css';

const AffiliatesNavbar = () => {
  return (
    <div className="sidebar-container">
      <SidebarBrand label="Espace partenaire" />
      <div className="sidebar-item">
        <NavLink
          to="/affiliatesdashboard"
          end
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaHome size={20} />
          <span>Accueil</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/affiliatestransactions"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaReceipt size={20} />
          <span>Transactions</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/affiliatesdocs"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaFileInvoiceDollar size={20} />
          <span>Documents</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/affiliatesprofil"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaUser size={20} />
          <span>Mon profil</span>
        </NavLink>
      </div>
    </div>
  );
};

export default AffiliatesNavbar;
